import React from "react"
import SEO from "../components/seo"
import PMPLayout from "../components/index-components/pmp-layout"
import PMPHeader from "../components/index-components/pmp-header"
import PressHero from "../components/press/press-hero"
import RequestDemoSection from "../components/request-demo-section"
import mockPressCardImage from "../assets/press/Caley-main-desktop.png"
import mockPressCardImageMobile from "../assets/press/Caley-main-mobile.png"
import mock2PressCardImage from "../assets/press/inpowered-openx-precisely-main-desktop.png"
import mock2PressCardImageMobile from "../assets/press/inpowered-openx-precisely-main-mobile.png"
import decisioningOSPressCardImage from "../assets/press/decisioningos-pmg-main-desktop.png"
import decisioningOSPressCardImageMobile from "../assets/press/decisioningos-pmg-main-mobile.png"

class PressPage extends React.Component {
  componentDidMount() {
    document.body.classList.add("press-page")
  }

  componentWillUnmount() {
    document.body.classList.remove("press-page")
  }

  render() {
    const pressReleases =
      this.props.data?.allWordpressWpPressReleases?.nodes || []

    const mockPressRelease = {
      id: "inpowered-ai-appoints-svp",
      title: "inPowered AI Appoints Former Index Exchange VP Caley Lewis as ut whSVP, Sales Following Rapid Growth on Index Platform",
      imageUrl: mockPressCardImage,
      imageUrlMobile: mockPressCardImageMobile,
      acf: {
        title: "inPowered AI Appoints Former Index Exchange VP Caley Lewis as SVP, Sales Following Rapid Growth on Index Platform",
        slug: "inpowered-ai-appoints-svp",
        summary:
          "inPowered AI today announced the appointment of Caley Lewis, former VP, Sales (Americas) at Index Exchange, as SVP, Sales",
        published_date: "2026-02-25T00:00:00",
      },
    }

    const mock2PressRelease = {
      id: "containerized-ai-delivers-lower-cost",
      title: "inPowered AI, OpenX, and Precisely PlaceIQ Deliver 80% Lower Cost per Store Visit Through Containerized AI Decisioning",
      imageUrl: mock2PressCardImage,
      imageUrlMobile: mock2PressCardImageMobile,
      acf: {
        title: "inPowered AI, OpenX, and Precisely PlaceIQ Deliver 80% Lower Cost per Store Visit Through Containerized AI Decisioning",
        slug: "containerized-ai-delivers-lower-cost",
        summary:
          "Custom AI model trained on PlaceIQ visitation data and deployed directly within OpenX supply infrastructure enables real-time impression-level decisioning before the bid, driving superior in-store visitation outcomes",
        published_date: "2026-06-24T00:00:00",
      },
    }

    const decisioningOSPressRelease = {
      id: "inpowered-ai-opens-decisioningos-to-agencies",
      title: "inPowered AI Opens DecisioningOS to Agencies, Launching with PMG",
      imageUrl: decisioningOSPressCardImage,
      imageUrlMobile: decisioningOSPressCardImageMobile,
      acf: {
        title: "inPowered AI Opens DecisioningOS to Agencies, Launching with PMG",
        slug: "inpowered-ai-opens-decisioningos-to-agencies",
        summary:
          "Enabling agencies to power their SSP marketplaces with proprietary, containerized AI.",
        published_date: "2026-10-05T00:00:00",
      },
    }

    return (
      <PMPLayout showNavigation>
        <SEO
          title="Press Releases"
          description="The latest stories, partnerships, and milestones from inPowered AI - where sell-side AI decisioning meets breakthrough performance in programmatic advertising."
        />
        <PMPHeader />
        <PressHero
          pressReleases={[
            ...pressReleases,
            mockPressRelease,
            mock2PressRelease,
            decisioningOSPressRelease,
          ]}
        />

        <section className="background-blue-light">
          <RequestDemoSection formPlacement="Press Hero" />
        </section>
      </PMPLayout>
    )
  }
}

export default PressPage

export const pageQuery = graphql`
  query {
    allWordpressWpPressReleases(sort: { fields: date, order: DESC }) {
      nodes {
        id
        title
        acf {
          title
          slug
          summary
          published_date
          city_state
          text_1
          text_2
          quote
          about_inpowered
          heroImageDesktop {
            localFile {
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid_noBase64
                }
              }
            }
          }
          heroImageMobile {
            localFile {
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid_noBase64
                }
              }
            }
          }
        }
      }
    }
  }
`
